import React, { useMemo } from "react";
import { Paper, Typography, Box, Stack } from "@mui/material";

function normalizeSeries(data) {
  if (!Array.isArray(data) || data.length === 0) {
    // fallback: 7 dias “mock”
    return [
      { label: "S", value: 3 },
      { label: "T", value: 6 },
      { label: "Q", value: 4 },
      { label: "Q", value: 7 },
      { label: "S", value: 5 },
      { label: "S", value: 8 },
      { label: "D", value: 2 },
    ];
  }

  // aceita formatos: {label,value} ou {name,value} etc.
  return data.map((d, i) => ({
    label: d.label || d.name || `D${i + 1}`,
    value: Number(d.value ?? d.total ?? d.count ?? 0),
  }));
}

export default function PerformanceMiniChart({
  title = "Performance",
  subtitle,
  data,
}) {
  const series = useMemo(() => normalizeSeries(data), [data]);

  const max = Math.max(...series.map((s) => s.value), 1);

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2.5,
        borderRadius: 3,
        border: "1px solid var(--border)",
        background: "var(--branco)",
      }}
    >
      <Typography sx={{ fontWeight: 800, color: "var(--cise-blue)" }}>
        {title}
      </Typography>

      {subtitle && (
        <Typography sx={{ fontSize: 13, color: "var(--cise-text-muted)", mb: 2 }}>
          {subtitle}
        </Typography>
      )}

      <Stack direction="row" spacing={1} alignItems="flex-end" sx={{ height: 120 }}>
        {series.map((s, idx) => {
          const h = Math.round((s.value / max) * 100);
          return (
            <Box key={idx} sx={{ flex: 1, textAlign: "center" }}>
              <Box
                sx={{
                  height: `${h}%`,
                  minHeight: 8,
                  borderRadius: 2,
                  background: "rgba(0, 122, 255, 0.35)",
                  border: "1px solid rgba(0, 122, 255, 0.25)",
                }}
              />
              <Typography sx={{ fontSize: 12, color: "var(--cise-text-muted)", mt: 0.8 }}>
                {s.label}
              </Typography>
            </Box>
          );
        })}
      </Stack>
    </Paper>
  );
}